// The one place a "quick task" is created (mobile overhaul Phase 0 §0.4.5).
// ⌘E compose in the CommandPalette and the mobile quick-add sheet both call
// this, so "due today, no project" stays identical on both paths.

import { melbourneToday } from '../../shared/dates';
import { api } from './api';

/** POSTs the task. `api()` already fires `ss:mutated` for every non-GET
    (lib/api.ts), which is what refreshes Shell's badges — no second
    dispatch here. */
export async function createQuickTask(title: string, projectId: string | null): Promise<void> {
  await api('/api/admin/tasks', {
    method: 'POST',
    json: { title, project_id: projectId, due_date: melbourneToday() },
  });
}
